import { datadogLogs } from '@datadog/browser-logs';
import { getVNextFeatures } from '../../src/client/vNext/helpers/routing/getVNextFeatures';

if (CONFIG.dataDog.clientToken && CONFIG.dataDog.enabled) {
    datadogLogs.init({
        clientToken: CONFIG.dataDog.clientToken,
        site: 'datadoghq.eu',
        service: 'my-page-frontend',
        env: CONFIG.dataDog.environment,
        version: `${CONFIG.myPage.publication}:${process.env.FRONTEND_VERSION_HASH}`, // eslint-disable-line no-undef
        forwardErrorsToLogs: false,
        sessionSampleRate: 100,
    });

    datadogLogs.setGlobalContextProperty('domain', 'user');
    datadogLogs.setGlobalContextProperty('publication', CONFIG.myPage.publication);
    datadogLogs.setGlobalContextProperty('vNextFeatures', getVNextFeatures());
}
